(ns app.front.view.admin.commands.create-inspection-groups
  (:require [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-candidates
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :admin.inspection-groups/get-candidates
                 :method     :get
                 :on-success [::fetch-candidates.success]}]}))

(rf/reg-event-db ::fetch-candidates.success
  (fn [db [_ _ resp]]
    (assoc db ::candidates resp)))

(rf/reg-sub ::candidates :-> ::candidates)

(rf/reg-event-db ::select-group
  (fn [db [_ group]]
    (assoc db ::selected-group group)))

(rf/reg-sub ::selected-group :-> ::selected-group)

(rf/reg-event-fx ::create-groups
  (fn [_ [_ group-id]]
    {:dispatch [:comm/command-monitored
                {:command    :admin.inspection-groups/create-groups
                 :method     :post
                 :data       (util/mmap group-id)
                 :notify     {:success "Inspector and dispatcher groups created"}
                 :on-success [::create-groups.success]}]}))

(rf/reg-event-fx ::create-groups.success
  (fn [{:keys [db]} _]
    {:db       (dissoc db ::selected-group)
     :dispatch [::fetch-candidates]}))

(defn view [match]
  (let [candidates     (<sub [::candidates])
        selected-group (<sub [::selected-group])
        tr             (<sub [:tr])
        loading?       (or (<sub [:comm/command-processing? :admin.inspection-groups/get-candidates])
                           (<sub [:comm/command-processing? :admin.inspection-groups/create-groups]))]
    [acommon/admin-page (util/mmap {:title "Create inspection groups"} match)
     [:section
      (cond
        loading?
        [section/section-skeleton]

        (seq candidates)
        [:<>
         [ui/help
          (str "Authority groups with the inspections feature enabled need inspector and dispatcher "
               "user groups with corresponding grants. This tool finds authority groups that are "
               "missing these groups and lets you create them.\n\n"
               "Select an authority group from the dropdown and click \"Create groups\" to create "
               "the missing inspector and dispatcher user groups and their grants.")]
         [:div.mt-4
          [:div {:style {:max-width "400px"}}
           [ui-select/select
            {:id          "select-authority-group"
             :values      candidates
             :value       selected-group
             :val->str    (fn [{:keys [group/name group/id]}]
                            (str name " (" id ")"))
             :on-change   #(>evt [::select-group %])
             :label-text  "Authority group"
             :select-text "Select authority group"}]]
          [:div.mt-4
           [ui/modal-confirmation-button
            (util/mmap {:id                  "create-inspection-groups"
                        :disabled?           (nil? selected-group)
                        :trigger-button-text "Create groups"
                        :on-yes-click        (fn [_]
                                               (>evt [::create-groups (:db/id selected-group)]))}
                       tr)
            [:p "Create inspector and dispatcher user groups for "
             [:span.font-bold (:group/name selected-group)]
             "?"]]]]]

        (some? candidates)
        [ui/warning "All authority groups already have inspection groups."])]]))

(def route
  {:name        :view/admin.commands.create-inspection-groups
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-candidates]))}]})
